module.exports = __webpack_public_path__ + "static/img/79024J_1_R_20200812_LC.c7d542d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/79024J_1_R_20200812_LC.png
// module id = Isnc
// module chunks = 0